let base_api_url

const root = process.env.REACT_APP_ENV
if (root === 'prod') {
	base_api_url = 'http://api.amedu.cn'
} else {
	// base_api_url = 'http://api.amedu.dev.eduugo.com'
	base_api_url = 'http://api.amedu.cn'
}

module.exports={
	base_api_url,
}
